// Keep this in sync with pinecast.helpers
const currencyDivisors: Record<string, number> = {
  // Everything not listed here is two-decimal

  // 3-decimal currencies
  BHD: 1000,
  IQD: 1000,
  JOD: 1000,
  KWD: 1000,
  LYD: 1000,
  OMR: 1000,
  TND: 1000,
  // One decimal currencies
  AED: 10,
  // Zero decimal currencies
  BIF: 1,
  CLP: 1,
  DJF: 1,
  GNF: 1,
  JPY: 1,
  KMF: 1,
  KRW: 1,
  MGA: 1,
  PYG: 1,
  RWF: 1,
  UGX: 1,
  VND: 1,
  VUV: 1,
  XAF: 1,
  XOF: 1,
  XPF: 1,
};

export function formatCurrency(amount: number, currency: string) {
  const currencyUpper = currency.toUpperCase();
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyUpper,
  }).format(amount / (currencyDivisors[currencyUpper] ?? 100));
}
export function currencyAmountToHumanReadableFloat(
  amount: number,
  currency: string,
) {
  const currencyUpper = currency.toUpperCase();
  return amount / (currencyDivisors[currencyUpper] ?? 100);
}
